import "./DividerSale.css";

export const DividerSale = () => {
  return (
    <div className="divider">
      <h2>THE WINTER SALE IS HERE</h2>
      <p>Use code <b>LOCHLANN</b> for -10% on all products!</p>
    </div>
  );
};
